import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';

const REQUISITOS = [
    { label: 'Mínimo 6 caracteres', test: v => v.length >= 6 },
    { label: 'Al menos una letra', test: v => /[a-zA-Z]/.test(v) },
    { label: 'Al menos un número',  test: v => /\d/.test(v) },
];

function calcularFortaleza(pwd) {
    const cumplidos = REQUISITOS.filter(r => r.test(pwd)).length;
    if (!pwd) return { nivel: 0, label: '', color: '#e2e8f0' };
    if (cumplidos === 1) return { nivel: 1, label: 'Débil',    color: '#ef4444' };
    if (cumplidos === 2) return { nivel: 2, label: 'Regular',  color: '#f59e0b' };
    return                      { nivel: 3, label: 'Fuerte',   color: '#10b981' };
}

export default function ModalCambiarPassword({ abierto, onCerrar }) {
    const [actual,   setActual]   = useState('');
    const [nueva,    setNueva]    = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [verActual,   setVerActual]   = useState(false);
    const [verNueva,    setVerNueva]    = useState(false);
    const [verConfirmar, setVerConfirmar] = useState(false);
    const [loading,  setLoading]  = useState(false);
    const [error,    setError]    = useState('');
    const [exito,    setExito]    = useState(false);

    // Resetear al abrir
    useEffect(() => {
        if (abierto) {
            setActual(''); setNueva(''); setConfirmar('');
            setVerActual(false); setVerNueva(false); setVerConfirmar(false);
            setError(''); setExito(false); setLoading(false);
        }
    }, [abierto]);

    if (!abierto) return null;

    const fortaleza = calcularFortaleza(nueva);
    const coinciden = nueva && confirmar && nueva === confirmar;
    const noCoinciden = nueva && confirmar && nueva !== confirmar;

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');

        if (!actual || !nueva || !confirmar) {
            setError('Completa todos los campos.');
            return;
        }
        if (nueva.length < 6) {
            setError('La nueva contraseña debe tener al menos 6 caracteres.');
            return;
        }
        if (nueva !== confirmar) {
            setError('Las contraseñas nuevas no coinciden.');
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.put(
                config.api_url + '/api/auth/cambiar-password',
                { password_actual: actual, password_nueva: nueva, confirmar },
                { headers: { token } }
            );
            if (res.data.status === 'success') {
                setExito(true);
                setTimeout(onCerrar, 2200);
            } else {
                setError(res.data.message || 'Error al cambiar la contraseña.');
            }
        } catch (err) {
            setError((err.response && err.response.data && err.response.data.message) || 'Error de conexión.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div
            style={{
                position: 'fixed', inset: 0, zIndex: 99999,
                backgroundColor: 'rgba(0,0,0,0.55)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                backdropFilter: 'blur(4px)',
                animation: 'fadeIn .15s ease',
            }}
            onClick={e => { if (e.target === e.currentTarget) onCerrar(); }}
        >
            <div style={{
                background: '#fff', borderRadius: '20px', width: '100%', maxWidth: '420px',
                margin: '16px', boxShadow: '0 24px 60px rgba(0,0,0,0.18)',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <div style={{
                    background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
                    padding: '24px 28px 20px',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px', height: '40px', borderRadius: '10px',
                            background: 'rgba(242,101,34,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <i className="bi bi-key-fill" style={{ color: '#f26522', fontSize: '18px' }} />
                        </div>
                        <div>
                            <div style={{ color: '#fff', fontWeight: 700, fontSize: '16px' }}>Cambiar contraseña</div>
                            <div style={{ color: '#94a3b8', fontSize: '12px' }}>Actualiza tus credenciales de acceso</div>
                        </div>
                    </div>
                    <button
                        onClick={onCerrar}
                        style={{
                            background: 'rgba(255,255,255,0.08)', border: 'none', color: '#94a3b8',
                            width: '30px', height: '30px', borderRadius: '8px', cursor: 'pointer',
                            fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}
                    >
                        <i className="bi bi-x" />
                    </button>
                </div>

                {/* Pantalla de éxito */}
                {exito ? (
                    <div style={{ padding: '48px 28px', textAlign: 'center' }}>
                        <div style={{
                            width: '72px', height: '72px', borderRadius: '50%',
                            background: '#f0fdf4', margin: '0 auto 20px',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <i className="bi bi-check-lg" style={{ fontSize: '36px', color: '#10b981' }} />
                        </div>
                        <p style={{ fontWeight: 700, fontSize: '18px', color: '#1e293b', marginBottom: '6px' }}>
                            ¡Contraseña actualizada!
                        </p>
                        <p style={{ color: '#64748b', fontSize: '14px' }}>
                            Cerrando en un momento…
                        </p>
                    </div>
                ) : (
                    /* Formulario */
                    <form onSubmit={handleSubmit} style={{ padding: '24px 28px' }}>

                        {/* Campo contraseña actual */}
                        <Campo
                            label="Contraseña actual"
                            value={actual}
                            onChange={setActual}
                            ver={verActual}
                            onVer={() => setVerActual(v => !v)}
                        />

                        <div style={{ height: '1px', background: '#f1f5f9', margin: '18px 0' }} />

                        {/* Campo nueva contraseña */}
                        <Campo
                            label="Nueva contraseña"
                            value={nueva}
                            onChange={setNueva}
                            ver={verNueva}
                            onVer={() => setVerNueva(v => !v)}
                        />

                        {/* Barra de fortaleza */}
                        {nueva && (
                            <div style={{ marginTop: '8px', marginBottom: '4px' }}>
                                <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
                                    {[1,2,3].map(i => (
                                        <div key={i} style={{
                                            flex: 1, height: '4px', borderRadius: '4px',
                                            background: i <= fortaleza.nivel ? fortaleza.color : '#e2e8f0',
                                            transition: 'background .3s',
                                        }} />
                                    ))}
                                </div>
                                <div style={{ fontSize: '11px', color: fortaleza.color, fontWeight: 600 }}>
                                    {fortaleza.label}
                                </div>
                                <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    {REQUISITOS.map(r => (
                                        <div key={r.label} style={{
                                            display: 'flex', alignItems: 'center', gap: '6px',
                                            fontSize: '11px',
                                            color: r.test(nueva) ? '#10b981' : '#94a3b8',
                                        }}>
                                            <i className={r.test(nueva) ? 'bi bi-check-circle-fill' : 'bi bi-circle'} />
                                            {r.label}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Campo confirmar */}
                        <div style={{ marginTop: '14px' }}>
                            <Campo
                                label="Confirmar nueva contraseña"
                                value={confirmar}
                                onChange={setConfirmar}
                                ver={verConfirmar}
                                onVer={() => setVerConfirmar(v => !v)}
                                estado={coinciden ? 'ok' : noCoinciden ? 'error' : null}
                            />
                            {noCoinciden && (
                                <p style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px' }}>
                                    Las contraseñas no coinciden
                                </p>
                            )}
                        </div>

                        {/* Error general */}
                        {error && (
                            <div style={{
                                marginTop: '16px', padding: '10px 14px',
                                background: '#fef2f2', border: '1px solid #fecaca',
                                borderRadius: '10px', color: '#dc2626',
                                fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px',
                            }}>
                                <i className="bi bi-exclamation-circle-fill" />
                                {error}
                            </div>
                        )}

                        {/* Botones */}
                        <div style={{ display: 'flex', gap: '10px', marginTop: '24px' }}>
                            <button
                                type="button"
                                onClick={onCerrar}
                                style={{
                                    flex: 1, padding: '12px',
                                    background: '#f1f5f9', border: 'none', borderRadius: '12px',
                                    color: '#64748b', fontWeight: 600, fontSize: '14px', cursor: 'pointer',
                                }}
                            >
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    flex: 2, padding: '12px',
                                    background: loading ? '#94a3b8' : '#f26522',
                                    border: 'none', borderRadius: '12px',
                                    color: '#fff', fontWeight: 700, fontSize: '14px',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                                    transition: 'background .2s',
                                }}
                            >
                                {loading
                                    ? <><span className="spinner-border spinner-border-sm" /> Guardando…</>
                                    : <><i className="bi bi-check2" /> Cambiar contraseña</>
                                }
                            </button>
                        </div>
                    </form>
                )}
            </div>

            <style>{`
                @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
            `}</style>
        </div>
    );
}

function Campo({ label, value, onChange, ver, onVer, estado }) {
    const borderColor = estado === 'ok' ? '#10b981' : estado === 'error' ? '#ef4444' : '#e2e8f0';
    return (
        <div>
            <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>
                {label}
            </label>
            <div style={{ position: 'relative' }}>
                <input
                    type={ver ? 'text' : 'password'}
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    autoComplete="new-password"
                    style={{
                        width: '100%', padding: '11px 42px 11px 14px',
                        border: `1.5px solid ${borderColor}`,
                        borderRadius: '10px', fontSize: '14px', outline: 'none',
                        transition: 'border-color .2s',
                        boxSizing: 'border-box',
                    }}
                    onFocus={e => { if (!estado) e.target.style.borderColor = '#f26522'; }}
                    onBlur={e =>  { if (!estado) e.target.style.borderColor = '#e2e8f0'; }}
                />
                <button
                    type="button"
                    onClick={onVer}
                    tabIndex={-1}
                    style={{
                        position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
                        background: 'none', border: 'none', cursor: 'pointer',
                        color: '#94a3b8', fontSize: '16px', padding: '2px',
                        display: 'flex', alignItems: 'center',
                    }}
                >
                    <i className={ver ? 'bi bi-eye-slash' : 'bi bi-eye'} />
                </button>
            </div>
        </div>
    );
}
